import { Clock } from "lucide-react";

export const DashboardHeader = () => {
  return (
    <div className="flex flex-col gap-4 mb-8 animate-fade-in">
      <div>
        <h1 className="text-3xl md:text-4xl font-bold bg-gradient-to-r from-primary via-primary-light to-primary-dark bg-clip-text text-transparent">
          Dashboard Overview
        </h1>
        <p className="text-muted-foreground mt-2">
          Welcome back! Here's what's happening with your business today.
        </p>
      </div>
      <div className="flex items-center gap-2 text-sm text-muted-foreground glass-card px-4 py-2">
        <Clock className="h-4 w-4" />
        <span className="truncate">Last updated: {new Date().toLocaleString()}</span>
      </div>
    </div>
  );
};